import React, { forwardRef } from 'react';
import { Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const FolioLink = forwardRef(function FolioLink(
	{ to, stopPropagation = false, onClick, sx, color = 'inherit', children, ...props },
	ref,
) {
	return (
		<Link
			ref={ref}
			component={RouterLink}
			underline='none'
			color={color}
			{...props}
			to={to}
			onClick={(event) => {
				if (stopPropagation) event.stopPropagation();
				onClick?.(event);
			}}
			sx={[{ textDecoration: 'none' }, sx]}
		>
			{children}
		</Link>
	);
});

FolioLink.displayName = 'FolioLink';

export default FolioLink;
